import { useState, useEffect, useCallback } from 'react';

import useNotifyServerError from './useNotifyServerError';

/**
 * Custom hook to fetch data from the server
 * This hook return the data return by the api and the loading state as { data, loading }
 * In case of error the hook show up the error into the React Admin notification component
 * @param {function} fetchFunc the function to execute the API call
 * @param {*} payload the payload to pass to the fetchFunc function
 */
export const useFetch = (fetchFunc, payload) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const notifyServerError = useNotifyServerError();

  const func = useCallback(async () => {
    try {
      const data = await fetchFunc(payload);
      setData(data);
      setLoading(false);
    } catch (error) {
      notifyServerError(error);
    }
  }, [fetchFunc, payload, notifyServerError]);

  useEffect(() => {
    func();
  }, [func]);

  return { data, loading };
};
